import { NgModule } from "@angular/core";
import { RegistrationNavigationComponent } from "./registration-navigation.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
    declarations: [RegistrationNavigationComponent],
    imports: [
        CommonModule,
        FGBSharedModule,
        RouterModule,
      ],
    exports: [RegistrationNavigationComponent]
})
export class RegistrationNavigationModule {}